{
  "version": 1,
  "asset_id": "58d16982-8762-4d01-a7ff-4221276a2a37",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/58d16982-8762-4d01-a7ff-4221276a2a37/opt_assistido-5.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/58d16982-8762-4d01-a7ff-4221276a2a37/opt_assistido-5.jpg",
  "original_filename": "opt_assistido-5.jpg",
  "size": 82207,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:07Z"
}
